import ReactGA from 'react-ga4';
import { loadScript } from '../load-script';
import { GA_CUSTOM_MAP } from './constants';
import { gtag } from '@mm/plugins/GoogleAnalytics';

// We need to send different events to two different Google Analytics accounts.
//
// For mobilemonkey.com analytics we use gtag.js
// for app.mobilemonkey.com analytics we will use analytics.js
export const initWebsiteGoogleAnalytics = () => {
  try {
    const ID = WEBSITE_GA_ID;
    const domains = WEBSITE_GA_DOMAINS || [];

    if (ID) {
      loadScript({
        src: `https://www.googletagmanager.com/gtag/js?id=${ID}`,
        async: true,
      });

      gtag('js', new Date());
      gtag('set', { cookie_flags: 'SameSite=None;Secure' });
      gtag('config', ID, {
        cookie_flags: 'SameSite=None;Secure',
        send_page_view: false,
        linker: {
          domains,
        },
        custom_map: GA_CUSTOM_MAP,
      });
    }
  } catch (e) {}
};

type GARecord = Record<string, string | boolean | number>;

type GAEventPayload = {
  category: string;
  label?: string;
  value?: number;
  interactive?: boolean;
  params?: GARecord;
};

// track event to mobilemonkey.com website GA property
export const trackWebsiteGAEvent = (name: string, payload: GAEventPayload) => {
  const { category, label, value, params, interactive = true } = payload;

  const opts: GARecord = {};

  if (category) opts.event_category = category;
  if (label) opts.event_label = label;
  if (value) opts.event_value = value;
  if (!interactive) opts.non_interaction = true;

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      opts[key] = value;
    });
  }

  gtag('event', name, opts);
};

// track event to dynamically provided google analytics property in env config
export const trackWebAppGAEvent = (name: string, payload: GAEventPayload) => {
  const { category, label, value, params, interactive = true } = payload;

  ReactGA?.event?.({
    action: name,
    category,
    label,
    value,
    nonInteraction: !interactive,
  });
};
